import React from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";

import { validateCheckOnlyModified } from "./SettingsValue";

//export const SelectOption = props => (
//	<option value={props.value}>
//		<FormattedMessage id={props.i18n_key}>
//			{/* <option> darf kein <span> als child haben */
//				text => text
//			}
//		</FormattedMessage>
//	</option>
//);

export const SelectOption = injectIntl(({i18n_key, intl}) => (
	<option>
		{intl.formatMessage({id: i18n_key})}
	</option>
));

SelectOption.propTypes = {
	value: PropTypes.string.isRequired,
	i18n_key: PropTypes.string.isRequired
};

export const SelectOptionDirect = props => (
	<option value={props.value}>
		{props.value}
	</option>
);

SelectOptionDirect.propTypes = {
	value: PropTypes.string.isRequired
};

const SelectControl = props => (
	<FormGroup validationState={validateCheckOnlyModified(props.local, props.prop)}>
		<ControlLabel>
			<FormattedMessage id={props.i18n_key} />
		</ControlLabel>
		<FormControl name={props.prop} componentClass="select"
			value={props.local[props.prop].value || ""}
			onChange={props.handleChange}>
			{props.children}
		</FormControl>
	</FormGroup>
);

SelectControl.propTypes = {
	i18n_key: PropTypes.string.isRequired,
	prop: PropTypes.string.isRequired,
	local: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.element),
		PropTypes.element
	])
};

export default SelectControl;
